/**
 * The stations that stand in the hub. One import and one entry each.
 *
 * The order is part of the determinism contract: it is the order they are offered to
 * `stepInteractions` and the order their colliders enter the level, so two peers walking the same
 * room resolve the same station when two of them are somehow in reach at once.
 *
 * An entity id comes off that same order rather than out of a station file. An
 * `InteractableRef` is a kind plus a number, and the hub holds one of each kind today, so the
 * index is the only honest number available and the day a second stash arrives it stays unique
 * without anything being renumbered by hand.
 */

import { STASH_STATION } from '@/modes/hub/sim/stations/stash';
import { UPGRADE_TERMINAL_STATION } from '@/modes/hub/sim/stations/upgradeTerminal';
import { VENDOR_STATION } from '@/modes/hub/sim/stations/vendor';
import { ZONE_TERMINAL_STATION } from '@/modes/hub/sim/stations/zoneTerminal';
import type { HubStation } from '@/modes/hub/sim/stations/hubStationContract';
import type { InteractableRef } from '@/sim/world/interactableContract';

export const HUB_STATIONS: readonly HubStation[] = [
  STASH_STATION,
  VENDOR_STATION,
  UPGRADE_TERMINAL_STATION,
  ZONE_TERMINAL_STATION,
];

/** How this station is addressed by anything that holds a key on it. */
export function stationRef(index: number): InteractableRef {
  const station = HUB_STATIONS[index];
  if (station === undefined) throw new RangeError(`stationRef: no station at ${String(index)}`);
  return { kindId: station.kindId, entityId: index };
}
